import { ViteReactSSG } from "vite-react-ssg";
import "./lib/i18n";
import "./index.css";
import { routes } from "./routes";

export const createRoot = ViteReactSSG({
  routes,
  basename: import.meta.env.BASE_URL,
  future: { v7_startTransition: true, v7_relativeSplatPath: true },
});
